<template>
  <div>
    <v-overlay
        :absolute="absolute"
        :value="overlay"
    >
      <v-card
          light
          :width="cardWidth"
      >
        <v-card-text>
          <gmap-map
              v-if="mapLoading"
              ref="mapRef"
              :center="center"
              :zoom="zoom"
              :options="{
                       gestureHandling: 'cooperative',
                     }"
              style="width:100%;  height: 500px;"
          >
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
            ></gmap-marker>
          </gmap-map>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="primary"
              elevation="0"
              tile
              @click="overlay = false"
              class="ml-2 mb-2"
          >
            {{ $t('buttons.Hide map') }}
          </v-btn>
        </v-card-actions>
      </v-card>


    </v-overlay>
    <v-container fluid :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#FFF', 'background-image': 'url(' + getBackground + ')' }">
      <v-container class="contain-width">
        <div>
          <v-row>
            <v-col
                offset-md="1"
                md="10"
                sm="12"
                class="action-col"
            >
<!--              <v-card elevation="0">-->
<!--                <v-card-text>-->
                  <v-card v-if="verifying" height="300">
                    <v-card-text class="d-flex align-center justify-center" style="height: 100%">
                      <p class="text-center"><v-icon x-large>mdi mdi-spin mdi-loading</v-icon></p>
                    </v-card-text>
                  </v-card>

                  <v-stepper v-else v-model="e1">
                    <v-stepper-header>
                      <v-stepper-step
                          :complete="e1 > 1"
                          step="1"
                      >
                        {{ $t('Found tag') }}
                      </v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step
                          :complete="e1 > 2"
                          step="2"
                      >
                        {{ $t('Return options') }}
                      </v-stepper-step>

                      <v-divider v-if="tag && tag.is_public"></v-divider>

                      <v-stepper-step
                          v-if="tag && tag.is_public"
                          :complete="e1 > 3"
                          step="3"
                      >
                        {{ $t('Message owner') }}
                      </v-stepper-step>

                      <v-divider v-if="tag && tag.is_public"></v-divider>

                      <v-stepper-step v-if="tag && tag.is_public" step="4">
                        {{ $t('Complete') }}
                      </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1">
                          <p class="text-h4">{{ $t('Thank you for scanning a {brand} smart tag', {brand: brandName}) }}.</p>

                          <p class="text-body-1">{{ $t('We are on a mission to help return lost items to our members and contribute to saving the environment') }}.</p>

                          <p class="text-body-1">{{ $t('You have started a journey that we are sure the owner of the item will really appreciate') }}.</p>

                          <p class="text-body-1">{{ $t('All you need to do now is press go') }}.</p>
                        <ValidationObserver ref="scanObserver">
<!--                          <h2 class="black&#45;&#45;text mb-2">-->
<!--                            Found an item?-->
<!--                            <v-tooltip top>-->
<!--                              <template v-slot:activator="{ on }">-->
<!--                                <v-icon light v-on="on">info</v-icon>-->
<!--                              </template>-->
<!--                              <span>Enter the tag code in the box and click find</span>-->
<!--                            </v-tooltip>-->
<!--                          </h2>-->
                          <ValidationObserver ref="scanObserver">
                            <v-form @submit.prevent="handleSubmit" class="scan-form">
                              <ValidationProvider vid="code" :name="$t('labels.Code')" rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-model="code"
                                    :error-messages="errors[0]"
                                    :placeholder="$t('placeholders.Enter code here')"
                                    solo
                                    required
                                    filled
                                    rounded
                                    flat
                                    clearable
                                    outlined
                                    class="scan-field"
                                    :hint="$t('hints.Scan or enter the tag code in the box and click go')"
                                    persistent-hint
                                >
                                  <template v-slot:append-outer>
                                    <v-btn class="scan-button" @click="handleSubmit" :loading="loading"
                                           :disabled="loading">Go</v-btn>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
<!--                              <v-btn class="mr-4 scan-button" @click="handleSubmit" :loading="loading"-->
<!--                                     :disabled="loading">Go</v-btn>-->
                            </v-form>
                          </ValidationObserver>
                        </ValidationObserver>

                        <p class="mt-6 text-body-1">{{ $t("Don't worry – this process is safe and anonymous – {brand} will never share your details", {brand: brandName}) }}.</p>

                      </v-stepper-content>

                      <v-stepper-content step="2">
                        <v-row>
                          <v-col class="col-12">
                            <p class="text-h4">{{ $t('You now have the following options to return the item to its owner') }}.</p>
                          </v-col>
                        <v-col class="col-12 col-sm-12 col-md-4">


                          <div v-if="tag && tag.organisation && tag.organisation.terms_agreed">
                            <h4 class="text-h4 mb-2">{{ $t('Drop it off here') }}</h4>
                            <p class="text-body-1 mt-0">
                              {{ tag.organisation.name }}<br>
                              {{ tag.organisation.address1 }}<br>
                              <span v-if="tag.organisation.address2">{{ tag.organisation.address2 }}<br></span>
                              {{ tag.organisation.town }}<br>
                              {{ tag.organisation.county }}<br>
                              {{ tag.organisation.postcode }}<br>
                              <v-btn
                                  small
                                  tile
                                  elevation="0"
                                  color="primary"
                                  @click="overlay = !overlay"
                                  class="mt-3"
                              >
                                {{ $t('buttons.Show on map') }}
                                <v-icon
                                    right
                                    dark
                                >
                                  mdi-open-in-new
                                </v-icon>
                              </v-btn>
                            </p>

                            <!--                          <h2 v-if="tag.is_public" class="text-h2 d-none d-md-block">Or <v-btn tile elevation="0" color="primary" @click="scroll">message owner</v-btn></h2>-->
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-12 col-md-8">
                          <div v-if="tag && tag.organisation && tag.organisation.terms_agreed" class="mb-6">
                            <p class="text-h5">{{ $t('The organisation will ensure that the lost property is returned to the owner') }}.</p>
                            <p class="text-h5">{{ $t('This will complete the return, and no further action will be needed from yourself') }}.</p>
                            <p class="text-h5">{{ $t('Thank you for helping us on our mission to provide the UK with a lost property solution') }}. {{ $t('You can join us') }} <router-link
                                :to="{ name: 'home' }"
                            >{{ $t('here') }}</router-link></p>

<!--                            <h2 class="text-h2 d-md-none" v-if="tag.is_public">Or <v-btn tile elevation="0" color="primary" @click="scroll">message owner</v-btn></h2>-->
                          </div>
                        </v-col>
                        </v-row>



                        <div v-if="tag && tag.is_public">
                          <h2 class="text-h4 mb-3" ref="contactForm"><span v-if="tag.organisation && tag.organisation.terms_agreed">Or continue</span><span v-else>Continue</span> to the next step to <v-btn tile elevation="0" color="primary" @click="e1 = 3">
                            message owner
                            <v-icon
                                right
                                dark
                            >
                              mdi-chevron-right
                            </v-icon>
                          </v-btn></h2>
                          <p class="text-subtitle-1">{{ $t('You can communicate anonymously with the owner to organise the return') }}.</p>
                        </div>

                        <div v-if="tag && tag.organisation && !tag.organisation.terms_agreed && !tag.is_public">
                          <p class="text-h5">{{ $t("Whoops! It looks like the owner of this tag decided to make it private, or they don't have an active subscription") }}. {{ $t("Sorry but there are no options available to return this property to it's owner via Findmykit") }}. {{ $t("However, you could still try dropping it off at a local police station") }}.</p>
                        </div>

                        <v-btn
                            text
                            color="primary"
                            @click="e1 = 1"
                        >
                          <v-icon
                              left
                              dark
                          >
                            mdi-chevron-left
                          </v-icon>
                          {{ $t('buttons.Back') }}
                        </v-btn>
                        <v-spacer></v-spacer>

                      </v-stepper-content>

                      <v-stepper-content v-if="tag && tag.is_public" step="3">
                        <div>
                          <p class="text-h5">{{ $t("You can use the {brand} returns process, to arrange a safe secure and anonymous return, to the owner of the item you have found", {brand: brandName}) }}. {{ $t("Please enter your email and message below") }}.</p>
                          <p class="text-body-1">{{ $t("Your email address will not be revealed to the owner") }}. {{ $t("Please ensure you read and agree to the terms of our returns process") }}.</p>

                          <ValidationObserver ref="notifyObserver">
                            <v-form v-model="valid" @submit.prevent="handleNotify">
                              <ValidationProvider vid="name" :name="$t('labels.Name')" rules="required|max:32" v-slot="{ errors }">
                                <v-text-field
                                    v-model="name"
                                    :error-messages="errors[0]"
                                    :label="$t('labels.Name')"
                                    required
                                    :hint="$t('hints.Your name will not be revealed to the owner')"
                                    persistent-hint
                                    filled
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required|email" v-slot="{ errors }">
                                <v-text-field
                                    v-model="email"
                                    :error-messages="errors[0]"
                                    :label="$t('labels.Email')"
                                    required
                                    :hint="$t('hints.Your real email will not be revealed to the owner')"
                                    persistent-hint
                                    filled
                                ></v-text-field>
                              </ValidationProvider>
                              <ValidationProvider vid="message" :name="$t('labels.Message')" rules="required|max:500" v-slot="{ errors }">
                                <v-textarea
                                    v-model="message"
                                    :error-messages="errors[0]"
                                    :label="$t('labels.Message')"
                                    :hint="$t('hints.Please let the owner know what you have found and the condition it is in within a maximum of 500 characters')"
                                    persistent-hint
                                    counter
                                    filled
                                ></v-textarea>
                              </ValidationProvider>
                              <ValidationProvider vid="terms" :name="$t('labels.Terms')" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                                <v-checkbox
                                    v-model="terms"
                                    :error-messages="errors[0]"
                                    required
                                    class="ml-2"
                                >
                                  <template v-slot:label>
                                    <div>
                                      {{ $t("I agree to the") }}
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <a
                                              @click.prevent.stop="dialog = true"
                                              v-on="on"
                                          >
                                            {{ $t("terms and conditions") }}
                                          </a>
                                          <v-dialog
                                              v-model="dialog"
                                              max-width="600"
                                          >
                                            <v-card>
                                              <v-card-title class="headline">{{ $t('headings.Terms and Conditions') }}</v-card-title>

                                              <v-card-text>
                                                <FinderTerms/>
                                              </v-card-text>

                                              <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    color="green darken-1"
                                                    text
                                                    @click="rejectTerms"
                                                >
                                                  {{ $t('buttons.Disagree') }}
                                                </v-btn>

                                                <v-btn
                                                    color="green darken-1"
                                                    tile
                                                    dark
                                                    @click="acceptTerms"
                                                >
                                                  {{ $t('buttons.Agree') }}
                                                </v-btn>
                                              </v-card-actions>
                                            </v-card>
                                          </v-dialog>
                                        </template>
                                        {{ $t("Opens in popover") }}
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </v-checkbox>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>
                          <div class="d-flex justify-end">
                            <v-btn
                                text
                                color="primary"
                                @click="e1 = 2"
                            >
                              <v-icon
                                  left
                                  dark
                              >
                                mdi-chevron-left
                              </v-icon>
                              {{ $t('buttons.Back') }}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn tile elevation="0" color="primary" @click="handleNotify" :loading="loading"
                                   :disabled="loading">
                              {{ $t('buttons.Send') }}
                              <v-icon
                                  right
                                  dark
                              >
                                mdi-send
                              </v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-stepper-content>

                      <v-stepper-content v-if="tag && tag.is_public" step="4">
                        <div>
                          <p class="text-h5">{{ $t("Thank you! Your message has been sent to the owner of the item") }}. {{ $t("You are doing a good deed for our {brand} member", {brand: brandName}) }}. {{ $t("Please look out for an email at the address you provided") }}. {{ $t("We are on a mission to provide the UK with a lost property solution") }}. <router-link
                              :to="{ name: 'home' }"
                          >{{ $t('links.You can join us here') }}</router-link></p>
                        </div>

                        <v-btn
                            color="primary"
                            @click="findAnother"
                        >
                          {{ $t('buttons.Find another tag') }}
                        </v-btn>

                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>

<!--                </v-card-text>-->
<!--              </v-card>-->
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-container>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">{{ $t('buttons.Close') }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { store } from '../store';
import {tagService} from "../services";
import {gmapApi} from 'vue2-google-maps'
import FinderTerms from './FinderTerms'

import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {i18n} from "../i18n";
import {mapState} from "vuex";
// Add the required rule
extend('required', required);

extend('max', {
  validate: (value, { max }) => {
    const length = value && value.length;

    return length <= max;
  },
  params: ['max'],
  message: 'The {_field_} length must be a maximum of {max} characters'
});

export default {
  name: "Found",
  props: ['qrCode'],
  components: {
    FinderTerms
  },
  metaInfo () {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Found'),
      htmlAttrs: {
        lang: i18n.locale
      }
    }
  },
  data: () => ({
    absolute: true,
    opacity: 1,
    overlay: false,
    e1: 1,
    dialog: false,
    sent: false,
    message: null,
    name: null,
    email: null,
    terms: false,
    snack: false,
    snackColor: '',
    snackText: '',
    code: null,
    tag: null,
    center: { lat: 51.2, lng: 0.5 },
    markers: [],
    places: [],
    currentPlace: null,
    products: null,
    show: false,
    locations: [],
    icons: {},
    infowindow: null,
    place: null,
    zoom: 9,
    mapLoading: false,
    valid: false,
    loading: false,
    loader: 'loading',
    verifying: false
  }),
  mounted () {

    this.$gtag.pageview({
      page_path: '/found',
    })

    store.dispatch('alert/clear', {root: true})

    let user = store.getters['account/user']

    if(user && user.roles && user.roles.includes('organisation') && user.email_verified_at == null) {
      this.$router.push('verify')
    }
    else if (user && user.roles && user.roles.includes('organisation')) {
      this.$router.push('/dashboard')
    }

    if (this.qrCode) {
      this.verifying = true
      this.code = this.qrCode
      let that = this
      window.setTimeout(function() {
        that.verifyCode()
      }, 200);

    }
    else {
      this.verifying = false
    }
  },
  watch: {
    email (val) {
        console.log(val)
        console.log(this.email)

        if (val) {
          let wsRegex = /^\s+|\s+$/g;
          let replaced = val.replaceAll(wsRegex, "");
          console.log("[" + replaced + "]")
          this.email = replaced
        }
    },
    overlay (val) {
      if (val) {
        this.doMap()
      }
    },
    e1 (val) {
      document.getElementById("scrolling-content").scrollTop = 0

      if (val === 3) {
        this.message = null
        this.name = null
        this.email = null
        this.terms = false
      }
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    getBackground() {
      if (this.brand === 'neotag') {
        return require('@/assets/neotag-background.jpg')
      }
      else {
        return require('@/assets/neotag-background.jpg')
      }
    },
    google: gmapApi,
    cardWidth() {
      return window.innerWidth / 1.2
    },
    cardHeight() {
      return window.innerHeight / 1.2
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    trimEmail() {
      console.log('changed')
    },
    findAnother() {
      this.e1 = 1
      this.code = null
      this.tag = null
      if (this.qrCode) {
        this.$router.push('/found').then(() => {
          document.getElementById("scrolling-content").scrollTop = 0
        })
      }
    },
    acceptTerms() {
      this.dialog = false
      this.terms = true
    },
    rejectTerms() {
      this.dialog = false
      this.terms = false
    },
    scroll() {
      let element = this.$refs.contactForm;
      let top = element.offsetTop;

      document.getElementById("scrolling-content").scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });
    },
    verifyCode () {
      this.sent = false

      this.tag = null;
      store.dispatch('alert/clear', {root: true})

      this.verifying = true

      const { code } = this;

      let codeString = code;

      // trim off trailing slash from older urls
      let lastChar = codeString.charAt(codeString.length - 1)

      if (lastChar === '/') {
        codeString = codeString.slice(0, -1);
      }

      let n = codeString.lastIndexOf('/');
      if (n >= 0) {
        codeString = codeString.substring(n + 1);
        this.code = codeString;
      }

      let that = this;

      tagService.findAnonymous(codeString).then(response => {

        that.tag = response.data;

        // handle instant activate
        if (this.tag.is_activatable_free_sample || this.tag.product_item.sublimated) {
          that.$router.push({name: 'intro-activate', params: {qrCode: codeString}})
        }
        else {
          that.verifying = false
        }

        // this.notified = false;
        // this.found = true;
        // this.foundDialog = true;
      }).catch(function (error) {
        console.log(error)
        if (error.response && error.response.data && error.response.data.error) {
          store.dispatch('alert/error', error.response.data.error, {root: true});
        }

        that.verifying = false
      });
    },
    handleSubmit () {

      this.sent = false

      let observer = this.$refs.scanObserver;
      this.tag = null;
      store.dispatch('alert/clear', {root: true})

      observer.validate().then(success => {

        if (!success) {
          return;
        }

        this.loading = true

        const { code } = this;

        let codeString = code;

        // trim off trailing slash from older urls
        let lastChar = codeString.charAt(codeString.length - 1)

        if (lastChar === '/') {
          codeString = codeString.slice(0, -1);
        }

        let n = codeString.lastIndexOf('/');
        if (n >= 0) {
          codeString = codeString.substring(n + 1);
          this.code = codeString;
        }

        let that = this;

        tagService.findAnonymous(codeString).then(response => {

          this.loading = false

          this.tag = response.data;

          // handle instant activate
          if (this.tag.is_activatable_free_sample) {
              this.$router.push({name: 'intro-activate', params: {qrCode: codeString}})
          }


          this.locations = [];

          if (response.data.organisation) {
            let organisation = response.data.organisation
            if (organisation && organisation.terms_agreed) {
              console.log(organisation)
              let category = organisation.organisation_category.slug
              this.mapLoading = true
              this.locations.push([organisation.name, organisation.latitude, organisation.longitude, 4, category])
              this.center = { lat: parseFloat(organisation.latitude), lng: parseFloat(organisation.longitude) }

            }

          }
          console.log(response.data)

          this.e1 = 2

          observer.reset();
          // this.notified = false;
          // this.found = true;
          // this.foundDialog = true;
        }).catch(function (error) {
          console.log(error)
          if (error.response && error.response.data && error.response.data.error) {
            store.dispatch('alert/error', error.response.data.error, {root: true});
          }
          console.log(store.getters.validationErrors)
          observer.setErrors(store.getters.validationErrors);
          that.loading = false
        });

      })
    },
    organisationLogin () {
      this.$router.push('/login')
    },
    handleNotify () {
      console.log('notify')

      let observer = this.$refs.notifyObserver;

      observer.validate().then(success => {
        if (this.valid) {

          this.loading = true;

          const instance = axios.create({
            baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
            headers: {'Accept-Language': i18n.locale}
          });

          instance
              .post('/api/conversations', {
                tag: this.code,
                name: this.name,
                email_address: this.email,
                message: this.message.replace(/(?:\r\n|\r(?=\n)|\n(?=\r))/g, '\n\r'),
                brand_slug: this.brand
              })
              .then(response => {
                if (response.status === 200) {
                  this.snack = true
                  this.snackColor = 'success'
                  this.snackText = i18n.t('Your message has been sent')
                  this.sent = true
                  this.e1 = 4
                  this.email_address = null
                  this.message = null
                  this.loading = false;
                  observer.reset()
                }
              })
              .catch(error => {
                console.log(error)
                this.loading = false;
                if (error.response.status === 403) {
                  this.snack = true
                  this.snackColor = 'error'
                  this.snackText = error.response.data.errors[0]
                }
                else if (error.response.status === 422) {
                  observer.setErrors(error.response.data.errors);
                }

              })
        }
      });


    },
    doMap () {
      // http://kml4earth.appspot.com/icons.html
      let iconBase = 'https://maps.google.com/mapfiles/kml/paddle/';

      var marker, i;

      let markers = [];

      //var icons = this.icons;
      var infowindow

      function addMarkerWithTimeout(location, timeout, map, google) {

        window.setTimeout(function() {

          if (location[4] && location[1] && location[2]) {
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(location[1], location[2]),
              map: map,
              animation: google.maps.Animation.DROP
            });

            markers.push(marker);

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
              return function() {
                infowindow.setContent(location[0]);
                infowindow.open(map, marker);
              }
            })(marker, i));
          }

        }, timeout);

      }

      let that = this

      window.setTimeout(function() {
        if (that.$refs.mapRef) {
          that.$refs.mapRef.$mapPromise.then((map) => {
            infowindow = new that.google.maps.InfoWindow();

            for (i = 0; i < that.locations.length; i++) {
              console.log(that.locations[i])
              addMarkerWithTimeout(that.locations[i], i * 200, map, that.google);
            }
          })
        }
      }, 500);





    },
  }
}
</script>

<style>
  /*.v-application .scan-form {*/
  /*  display: flex;*/
  /*}*/
  .v-application--is-ltr .v-input__append-outer {
    margin-left: 0 !important
  }
  .v-application .scan-form .error--text {
    color: var(--v-primary-base) !important;
  }
  .action-col {
    min-height: 165px;
  }
  .theme--light.v-text-field--solo .v-input__control .v-input__slot {
    border-radius: 10px 0 0 10px !important;
  }
  .theme--dark.v-text-field--solo .v-input__control .v-input__slot {
    border-radius: 10px 0 0 10px !important;
  }
  .scan-field.v-text-field--filled, .scan-field.v-text-field--focused {
    width: 400px;
  }
  .scan-button {
    height: 56px !important;
    border-radius: 0 10px 10px 0 !important;
    display: inline-block !important;
    box-shadow: none;
    margin-left: 0;
    background-color: var(--v-primary-base) !important;
    color: #fff !important;
    text-transform: none;
    margin-top: -12px
  }

</style>
